export function parseLocalApiOverride(url: string) {
  let LOCAL_API_OVERRIDES: Array<string> = [];

  try {
    const overrides = localStorage.getItem('LOCAL_API_OVERRIDES');
    if (overrides) {
      LOCAL_API_OVERRIDES = JSON.parse(overrides);
      if (!Array.isArray(LOCAL_API_OVERRIDES)) {
        console.error(
          'LOCAL_API_OVERRIDES local storage key must be a stringified array'
        );
        return url;
      }
    }
  } catch (__error) {
    return url;
  }

  if (
    LOCAL_API_OVERRIDES.some((overrideString) => url.includes(overrideString))
  ) {
    return url
      .replace(/https:\/\/(app|api)/, 'https://local')
      .replace('/api/', '/');
  }

  return url;
}
